/* Patriot Engines store - shared behavior (vanilla, no dependencies) */
document.documentElement.classList.add('js');
(function () {
  'use strict';

  /* Mobile menu toggle */
  var burger = document.querySelector('.hdr-burger');
  var menu = document.getElementById('mobile-menu');
  if (burger && menu) {
    burger.addEventListener('click', function () {
      var open = menu.classList.toggle('open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Collapse filter groups by default on mobile */
  if (window.matchMedia('(max-width: 900px)').matches) {
    document.querySelectorAll('.coll-filters details.filter-group[open]').forEach(function (d) {
      d.removeAttribute('open');
    });
  }

  /* Header depth once the page scrolls */
  var hdr = document.querySelector('.hdr');
  if (hdr) {
    var onScroll = function () {
      hdr.style.boxShadow = window.scrollY > 8
        ? '0 1px 0 rgba(244,242,237,.12), 0 10px 26px rgba(3,17,32,.35)'
        : '0 1px 0 rgba(244,242,237,.12)';
    };
    addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Reveal on scroll (content is visible by default without JS; safety nets
     guarantee nothing ever stays hidden in headless or paused contexts) */
  var revealAll = function () {
    document.querySelectorAll('.reveal:not(.in)').forEach(function (el) { el.classList.add('in'); });
  };
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
    addEventListener('load', function () { setTimeout(revealAll, 2000); });
    setTimeout(revealAll, 6000);
  } else {
    revealAll();
  }

  /* Inert commerce controls: static preview, no backend */
  document.querySelectorAll('[data-inert]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); });
  });
})();


/* Parts collection: filter cards by category chip. Without JS every card shows. */
(function () {
  var chips = document.querySelectorAll('.chips .chip');
  var grid = document.getElementById('parts-grid');
  if (!chips.length || !grid) return;
  var cards = Array.prototype.slice.call(grid.querySelectorAll('.prod'));
  cards.forEach(function (card) {
    var t = card.querySelector('.prod-name');
    card.dataset.hay = (t ? t.textContent : '').toLowerCase();
  });
  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      chips.forEach(function (c) { c.classList.remove('is-on'); });
      chip.classList.add('is-on');
      var cat = (chip.dataset.cat || '').toLowerCase();
      var shown = 0;
      cards.forEach(function (card) {
        var hit = !cat || card.dataset.cat === cat || card.dataset.hay.indexOf(cat) > -1;
        card.hidden = !hit;
        if (hit) shown++;
      });
      grid.setAttribute('aria-label', shown + ' products');
    });
  });
})();
